import axios from "axios";

// Use an absolute backend URL when explicitly provided (production). In dev, fall
// back to a relative base ("/api") so the CRA dev server proxies requests to the
// backend defined by the "proxy" field in package.json — this avoids CORS and 404s.
const RAW_BACKEND = process.env.REACT_APP_BACKEND_URL;
const BACKEND =
  !RAW_BACKEND || RAW_BACKEND === "undefined" || RAW_BACKEND === "null"
    ? ""
    : RAW_BACKEND.replace(/\/+$/, "");

// Sessions are scoped per panel so an admin sign-in never hijacks a merchant
// session (and vice versa) inside the same browser.
export function currentScope() {
  const p = typeof window !== "undefined" ? window.location.pathname : "/";
  return p.startsWith("/admin") || p.startsWith("/control-panel") ? "admin" : "seller";
}

const keyFor = (scope) => `access_token_${scope || currentScope()}`;

export function getToken(scope) {
  return localStorage.getItem(keyFor(scope));
}

const api = axios.create({
  baseURL: `${BACKEND}/api`,
  // Cookies are intentionally disabled: they are shared across panels in one
  // browser, which caused merchant actions to be recorded as the admin.
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function setToken(token, scope) {
  if (token) localStorage.setItem(keyFor(scope), token);
  else localStorage.removeItem(keyFor(scope));
}

export default api;
